<form [formGroup]="form" class="relative w-full flex flex-wrap justify-center content-start">
    <!-- <span class="w-full text-sm font-medium text-start mb-2">{{mode == 'register' ? 'ثبت‌نام' : 'ورود'}}</span> -->
    <!-- <span class="w-full text-xs font-regular text-start mb-4">شمارهٔ موبایل یا آدرس ایمیل خود را وارد کن.</span> -->
    <app-auth-slider-presenter class="mb-8 w-full"></app-auth-slider-presenter>

    <input StandardNumber formControlName="userName"
        class="w-full dark:!text-gray-500 mb-6 !bg-white dark:!bg-gray-700 dark:!border-gray-700 border !border-[#BDBDBD] phoneInput" type="text"
        placeholder="شمارهٔ موبایل یا آدرس ایمیل">
    <button class="w-full btn btn btn-green-flat mb-2" [appButtonLoader]="getOtpLoading" [disabled]="form.invalid"
        (click)="submitUserName()">دریافت کد تأیید</button>
    <button class="w-full btn btn-green mb-4" (click)="loginWithPassword()">ورود با رمز عبور</button>
    <div class="w-full flex justify-between items-center mb-6">
        <span class="grow h-[1px] bg-[#EDEDED]"></span>
        <span class="grow-0 text-[#BDBDBD] mx-3">یا</span>
        <span class="grow h-[1px] bg-[#EDEDED]"></span>
    </div>
    <button class="relative w-full btn btn-green-outline">
        ورود با گوگل
        <img class="absolute w-7 h-6 left-4 top-1/2 -translate-y-1/2"
            src="https://cloud.behkhaan.ir/assets/images/auth/google-logo.svg" alt="google-logo">
    </button>
    <asl-google-signin-button class="absolute bottom-2 opacity-[0.01]" type='standard' size='medium' width="400">
    </asl-google-signin-button>
</form>